import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStyle } from '@composables/use-style';
import { useStyleExtension } from '@v1/composables/image';
import BaseImage from '@v1/components/base/BaseImage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImagePrimary',
  props: {
  asset: {
    type: [Object, String],
    required: false,
    default: null,
  },
  interactive: {
    type: Boolean,
    required: false,
    default: false,
  },
  round: {
    type: Boolean,
    required: false,
    default: false,
  },
  src: {
    type: String,
    required: false,
    default: '//:0',
  },
},
  setup(__props) {

const { spacing } = useStyle();

const props = __props;

const styleExtension = useStyleExtension({
  image: {
    borderRadius: props.round ? '50%' : spacing.SM,
    display: 'block',
    ...(props.interactive ? {
      filter: {
        '': 'none',
        hover: 'opacity(0.5)',
        active: 'opacity(0.5)',
        disabled: 'opacity(0.25)',
      },
      cursor: {
        '': 'pointer',
        disabled: 'default',
      },
    } : {}),
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseImage, _mergeProps(_ctx.$attrs, {
    src: __props.asset ? require(`@assets/${__props.asset}`) : __props.src,
    styleExtension: _unref(styleExtension)
  }), null, 16, ["src", "styleExtension"]))
}
}

})